module.exports = __webpack_public_path__ + "static/media/vidIconGreen.3d3e3a29.png";